import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';

// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Container, Grid, Paper, Typography, Alert } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useSettingsContext } from '../../components/settings';
import FormProvider from '../../components/hook-form';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { onPortalAddBrands, onPortalUpdateBrands } from '../../APIs/brands';
import { GridPaper, GridPaperSwitch } from '../../components/custom-grid-input';

const classes = {
    root: {
        flexGrow: 1
    },
    paper: {
        padding: 5,
        textAlign: "center",
        color: "inherit"
    }
};

/* eslint-disable react/prop-types */
const BrandView = ({ onChangeUser, item, onHandleClose, acids = [], readOnly = true }) => {
    const { themeStretch } = useSettingsContext();
    const axiosPrivate = useAxiosPrivate();

    const AddBrandSchema = Yup.object().shape({
        id: Yup.number(),
        name: Yup.string().max(50).required('Brand Name is required'),
        thumbnailURL: Yup.string(),
        storeLocatorURL: Yup.string(),
        keywords: Yup.string().max(50),
        isActive: Yup.boolean(),
        isApproved: Yup.boolean()
    });

    const defaultValues = {
        id: item?.id ?? 0,
        name: item?.name ?? '',
        isActive: item?.isActive ?? true,
        thumbnailURL: item?.thumbnailURL ?? '',
        storeLocatorURL: item?.storeLocatorURL ?? '',
        keywords: item?.keywords ?? '',
        isApproved: item?.isApproved ?? false
    };

    const methods = useForm({
        resolver: yupResolver(AddBrandSchema),
        defaultValues
    });

    const {
        setValue,
        reset,
        setError,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = methods;

    const handleSave = (request) => {
        const newRequest = { ...request }

        if (request.id > 0) {
            updateBrand(newRequest);
        }
        else {
            addBrand(newRequest);
        }
    }

    const addBrand = (request) => {
        onPortalAddBrands(axiosPrivate, request, (response) => {
            if (response.status === 201) {
                onChangeUser(response.data);
            }
            else {
                console.log('error', response);

                reset();

                setError('afterSubmit', {
                    ...response,
                    message: response.data,
                });
            }
        });
    }

    const updateBrand = (request) => {
        onPortalUpdateBrands(axiosPrivate, request, (response) => {
            if (response.status === 200) {
                onChangeUser(response.data);
            }
            else {
                console.log('error', response);

                reset();

                setError('afterSubmit', {
                    ...response,
                    message: response.data,
                });
            }
        });
    }

    return (
        <>
            <Helmet>
                <title>View Brands | flok</title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : 'xl'} spacing={{ xs: 0.5, sm: 1.5 }}>
                <FormProvider methods={methods} onSubmit={handleSubmit(handleSave)}>
                    <div style={classes.root}>
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant="h4" component="h4" paragraph>
                                    {readOnly ? 'View Brand' : `${item ? 'Update' : 'Add'} Brand`}
                                </Typography>
                                {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}
                            </Grid>
                            <GridPaper name="name" label='Name' xs={6} readOnly={readOnly} />
                            <GridPaper name="keywords" label='Keywords' xs={6} readOnly={readOnly} />
                            <GridPaper name="storeLocatorURL" label='Store Locator URL' xs={6} readOnly={readOnly} />
                            <GridPaper name="thumbnailURL" label='Thumbnail URL' xs={6} readOnly={readOnly} />
                            <GridPaperSwitch name="isActive" label='Is Active' xs={3} readOnly={readOnly} />
                            <GridPaperSwitch name="isApproved" label='Is Approved' xs={3} readOnly={readOnly} />
                            <Grid container item xs={12} spacing={1}>
                                <Grid item xs={2}>
                                    <Paper style={classes.paper}>
                                        {!readOnly &&
                                            <LoadingButton
                                                type="submit"
                                                variant="contained"
                                                loading={isSubmitSuccessful || isSubmitting}
                                            >
                                                {item ? "Update" : "Add"}
                                            </LoadingButton>
                                        }
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </FormProvider>
            </Container>
        </>
    )
}

export default BrandView;